import React, { useEffect, useState } from 'react';
import ProposalList from '../../../components/proposal'
const Product = (props) => {
    const seedData = [
        {
            name: "Quotation ID",
            value: '',
            key: 'quoteRefNumber',
            show: true
        },
        {
            name: "Product Name",
            value: '',
            key: 'coverageName',
            show: true
        },
        {
            name: "Sum Assured",
            value: '',
            key: 'coverageSumAssured',
            show: true
        },
        {
            name: "Annualized Premium",
            value: '',
            key: 'coverageAnnualizedPremium',
            show: true
        },
        {
            name: "Installment Premium",
            value: '',
            key: 'coverageInstallmentPremium',
            show: true
        }

    ]
    const [initialdata, setData] = useState(seedData);
    useEffect(() => {

            const { basicDetails } = props.proposalData;
            let data;
            data = seedData.map((item) => {
                if (basicDetails.coverageDetails[item.key]) {
                    item.value = basicDetails.coverageDetails[item.key];
                } else if (props.proposalData[item.key]) {
                    item.value = props.proposalData[item.key]
                }
                return item;
            })
            setData(data)

    }, []);
    return (
        <div className="main_container">
            <ProposalList initialdata={initialdata} />
        </div>
    )
}

export default Product;
